/**
 * Template Directory Service
 * Version: 0.0.2
 * Last Updated: 02-11-25
 * Author: Vertex Team
 * Description: Service Layer that provides centralized data and functionality for the templates.
 */

import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Section } from '../model/directory.model';

@Injectable({
  providedIn: 'root',
})
export class DirectoryService {
  private readonly http = inject(HttpClient);

  fetchDataFromApi(apiUrl: string): Observable<Section[]> {
    return this.http.get<Section[]>(apiUrl).pipe(
      catchError(error => {
        console.error('Error fetching data from API:', error);
        return of([]);
      })
    );
  }
}
